import { render, staticRenderFns } from "./CustomerAdd.vue?vue&type=template&id=4b3d4c94&scoped=true"
import script from "./CustomerAdd.vue?vue&type=script&lang=js"
export * from "./CustomerAdd.vue?vue&type=script&lang=js"
import style0 from "./CustomerAdd.vue?vue&type=style&index=0&id=4b3d4c94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3d4c94",
  null
  
)

export default component.exports